import { render, staticRenderFns } from "./Hotkey.vue?vue&type=template&id=3264e160"
import script from "./Hotkey.vue?vue&type=script&lang=js"
export * from "./Hotkey.vue?vue&type=script&lang=js"
import style0 from "./Hotkey.vue?vue&type=style&index=0&id=3264e160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports